import type { ReactNode } from 'react';

export const symbol_playing_cards: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m610-409 29-105q2-9-1-18t-11-14l-90-62q-6-5-13.34-2.12T514-599l-29 105q-2 9 1 18t11 14l90 62q6 5 13.34 2.12T610-409ZM195-160l-66-27q-32.17-14.03-43.58-48.01Q74-269 92-302l103-245v387Zm142 58q-33.83 0-57.91-24Q255-150 255-184v-313l137 368q3 8 6.5 14t9.5 13h-71Zm183-25q-23 8-45.93-2.2Q451.14-139.41 443-162L251-684q-8-23 2.44-45.88Q263.88-752.75 287-761l319-115q23-8 46.5 2t31.5 33l193 521q8 23-2.2 45.87Q864.59-251.25 842-243L520-127Zm-20-57 318-116-191-519-318 115 191 520Zm64-318Z"
		/>
	</svg>
);
